class LoginPageController {
    constructor($stateParams) {
        this.$stateParams = $stateParams;
        this.isReauthorizing = false;
    }
}

const loginPageComponentDefinition = {
    bindings: {
        authenticationMethod: '=?',
    },
    controller: ['$stateParams', LoginPageController],
    template: require('./login-page.component.html').trim(),
};

module.exports = {
    LoginPageController,
    loginPageComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/login/login-page.component.js